<template>
  <div v-if="currentCompte">
    <div class="row">
      <div class="col-lg-6 offset-lg-6 mt-lg-4">
        <button
          title="Aperçu"
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: listUrl,
                params: { id: currentCompte.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form
        @submit.prevent="submit"
        @keydown="form.onKeydown($event)"
        enctype="multipart/form-data"
      >
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>

        <div class="row">
          <div class="col-md-12 col-lg-3">
            <div class="card mb-n1">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-12">
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-center"
                    >
                      <img
                        v-if="urlImage"
                        class="rounded-circle"
                        alt="Image"
                        width="200"
                        height="200"
                        :src="urlImage"
                        data-holder-rendered="true"
                      />
                      <img
                        v-else
                        class="rounded-circle"
                        alt="Image"
                        width="200"
                        height="200"
                        :src="URL_LOCAL_FILE + '/images/no-image.png'"
                        data-holder-rendered="true"
                      />
                      <div class="mt-3">
                        <div>
                          <input
                            ref="imageUpload"
                            type="file"
                            style="display: none"
                            accept="image/*"
                            :class="{
                              'is-invalid': form.errors.has('logo'),
                            }"
                            @change="onChangeImage"
                          />
                          <has-error
                            :form="form"
                            field="image"
                            class="mb-4"
                          ></has-error>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex"
                      :class="
                        urlImage !== null
                          ? 'justify-content-between'
                          : 'justify-content-center'
                      "
                    >
                      <b-button
                        size="sm"
                        variant="outline-custom-primary"
                        @click="chooseImage"
                        ><i class="fas fa-image" aria-hidden="true"></i>
                        Changer
                      </b-button>
                      <b-button
                        v-if="urlImage"
                        size="sm"
                        variant="outline-danger"
                        @click="onClearImage"
                        ><i class="fas fa-trash" aria-hidden="true"></i>
                        Supprimer</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-9">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="email">Email de connexion </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('email'),
                        }"
                        id="email"
                        v-model="form.email"
                        type="email"
                        placeholder="Email de connexion"
                        maxlength="100"
                      />
                      <has-error :form="form" field="email"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="langue"
                        >Langue <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="langues"
                        :reduce="(langue) => langue.uuid"
                        v-model="form.langue"
                        placeholder="Langue"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="langue"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('langue'),
                          }"
                        />
                        <has-error :form="form" field="langue"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="centre_cout"
                        >Centre de coût
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="centreCouts"
                        :reduce="(centreCout) => centreCout.uuid"
                        v-model="form.centre_cout"
                        placeholder="Centre de coût"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="centre_cout"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('centre_cout'),
                          }"
                        />
                        <has-error :form="form" field="centre_cout"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-lg-0 pt-3">
                    <div class="custom-control custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="statut"
                        v-model="form.statut"
                      />
                      <label class="custom-control-label" for="statut"
                        >Peut se connecter ?</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-4">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-compte';
import Form from 'vform';
import { objectToFormData } from 'object-to-formdata';
import config from '@/config';
export default {
  data() {
    return {
      form: new Form({
        email: '',
        image: null,
        langue: '',
        centre_cout: '',
        statut: false,
      }),
      currentCompte: null,
      roles: [],
      langues: [],
      centreCouts: [],
      urlImage: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
    };
  },
  computed: {
    listUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  methods: {
    chooseImage() {
      this.$refs.imageUpload.click();
    },
    onChangeImage(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.urlImage = global.URL.createObjectURL(file);
      this.form.clear_image = false;
    },
    onClearImage() {
      this.form.image = null;
      this.urlImage = null;
      this.form.clear_image = true;
    },
    init() {
      this.langues = [];
      this.roles = [];
      this.centreCouts = [];

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.COMPTE + '/' + this.$route.params.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.langues = resp1.data.langues;
            this.roles = resp1.data.roles;
            this.centreCouts = resp1.data.centre_couts;

            this.currentCompte = resp2.data.compte;
            Object.assign(this.form, this.currentCompte);

            this.urlImage = this.form.url_image;
            delete this.form.url_image;
          })
        )
        .catch();
    },
    submit() {
      this.form._method = 'PUT';

      this.form
        .post(URL.COMPTE + '/' + this.$route.params.id, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
